// extracted by mini-css-extract-plugin
export var label = "Checkbox-module--label--5KnJY";
export var switcher = "Checkbox-module--switcher--f0BqO";
export var wrap = "Checkbox-module--wrap--OnryV";